import { authStore } from '../modules/auth/store';

export default {
  name: 'RouteAccessHelper',

  isAuthenticated() {
    const { loggedUser } = authStore.state;
    return (loggedUser !== undefined && loggedUser !== null);
  },

  isUserAuthorized(routeName) {
    /**  if the user is logged in, checking if the user has permissions to the page  */

    if (!this.isAuthenticated()) {
      return false;
    }

    const { userPermissions } = authStore.state;
    const foundUserPermission = userPermissions?.userPermissions?.find(
      (x) => x.routeName === routeName,
    );
    return (
      foundUserPermission !== null && foundUserPermission !== undefined
    );
  },

  isGuestAuthorized(routeName) {
    /**  checking if the guest has permissions to the page  */
    const { guestPermissions } = authStore.state;
    const foundGuestPermission = guestPermissions?.guestPermissions?.find(
      (x) => x.routeName === routeName,
    );
    return (
      foundGuestPermission !== null && foundGuestPermission !== undefined
    );
  },

  isAuthorized(routeName) {
    if (this.isAuthenticated()) {
      /**  if the user is logged in, checking if the user has permissions to the page  */
      return this.isUserAuthorized(routeName);
    }
    return this.isGuestAuthorized(routeName);
  },
};
